<h2
  mat-dialog-title
  [ngStyle]="{
    color: data.filterSettings.textColor,
    background: data.filterSettings.backgroundColor
  }"
>
  {{ 'COMMON.REVIEW_OR_LISTING_SOURCE' | translate }}
</h2>
<mat-dialog-content>
  <div class="location-selector">
    <forms-va-input-tags [formControl]="formControl" [options]="options$ | async"></forms-va-input-tags>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="close(false)">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="close(true)">
    {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
